import { Stack } from '@mui/material';
import { Provider, ResourceType } from '@repo/api-gw-sdk';
import type { InventoryResource } from '@repo/api-gw-sdk';

import { Loader } from '@/components/layout/loading';
import { useDAL } from '@/contexts/useDAL';

import { AwsSnapshotList } from './awsSnapshotList';
import { AzureRestorePointsList } from './azureRestorePointsList';
import { FsxBackupList } from './fsxBackupList';

interface ConvertSnapshotsListProps {
  resource: InventoryResource;
  selectedDate: Date;
  selectedOrigin?: 'eon' | 'other';
}

export const ConvertSnapshotsList = ({
  selectedDate,
  resource,
  selectedOrigin,
}: ConvertSnapshotsListProps) => {
  const dal = useDAL();
  const { data: providerSnapshots, isLoading } =
    dal.convert.useListCloudSnapshots(resource.id, selectedDate);

  if (isLoading) {
    return (
      <Stack key='loader' marginY='40px'>
        <Loader />
      </Stack>
    );
  }

  if (resource.resourceType === ResourceType.AwsFsx) {
    return (
      <FsxBackupList
        backups={providerSnapshots?.fsxBackups || []}
        selectedOrigin={selectedOrigin}
      />
    );
  }

  return resource.cloudProvider === Provider.Aws ? (
    <AwsSnapshotList
      resource={resource}
      snapshots={providerSnapshots?.snapshotsPerVolume || []}
    />
  ) : (
    <AzureRestorePointsList
      resource={resource}
      restorePoints={providerSnapshots?.restorePoints || []}
    />
  );
};
